﻿export class Watcher {
    constructor(type, format, url) {
        this._url = url;
        this._method = 'POST';
        this._credsValue = 'include';
        this._type = type;
        this._format = format;
        this.Status = '';

        this._timeOut = 4000;
        this._isPending = false;
        this.PollStart = async () => await this.start();
        this.PollEnd = () => this.stop();
        this.Request = () => this.request(this._type, this._format, false);
    }
    stop() {
        this._isPending = false;
    };
    async start() {
        this._isPending = true;
        return await this.request(this._type, this._format, this._isPending);
    };
    async send() {
        return await this.request(this._type, this._format, this._isPending);
    };
    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async request(type, format, poll) {
        let data = new FormData();
        data.append("type", type);
        data.append("format", format);

        let request = await fetch(
            `${this._url}`,
            {
                method: this._method,
                body: data,
                credentials: this._credsValue
            }
        );
        let result = await request.json();

        if (poll) {
            this.Status = result.data.status;

            if (this.Status == "Validating") {
                await this.timeout(this._timeOut);
                return await this.send();
            }
            else {
                this._isPending = false;
                return result;
            }
        }
        else {
            this._isPending = false;
            return result;
        }
    }
}